function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "mobile-landscape",
  transform: "translate(0.15 126.95) rotate(-90)",
  opacity: 0.9
}, React.createElement("g", {
  id: "Group_2007",
  "data-name": "Group 2007",
  transform: "translate(116.067 1.4)"
}, React.createElement("g", {
  id: "Group_2006",
  "data-name": "Group 2006",
  transform: "translate(0)"
}, React.createElement("path", {
  id: "Path_3045",
  "data-name": "Path 3045",
  d: "M209.934,25.6h-4.666a.467.467,0,0,0,0,.933h4.666a.467.467,0,0,0,0-.933Z",
  transform: "translate(-204.801 -25.6)",
  fill: "#403f50",
  stroke: "#403f50",
  strokeWidth: 0.3
}))), React.createElement("g", {
  id: "Group_2009",
  "data-name": "Group 2009",
  transform: "translate(123.534 1.4)"
}, React.createElement("g", {
  id: "Group_2008",
  "data-name": "Group 2008"
}, React.createElement("path", {
  id: "Path_3046",
  "data-name": "Path 3046",
  d: "M342.267,25.6H341.8a.467.467,0,0,0,0,.933h.467a.467.467,0,1,0,0-.933Z",
  transform: "translate(-341.334 -25.6)",
  fill: "#403f50",
  stroke: "#403f50",
  strokeWidth: 0.3
}))), React.createElement("g", {
  id: "Group_2011",
  "data-name": "Group 2011",
  transform: "translate(117 23.8)"
}, React.createElement("g", {
  id: "Group_2010",
  "data-name": "Group 2010"
}, React.createElement("path", {
  id: "Path_3047",
  "data-name": "Path 3047",
  d: "M224.313,435.2h-1.159a1.289,1.289,0,0,0-1.287,1.287v.225A1.289,1.289,0,0,0,223.154,438h1.159a1.289,1.289,0,0,0,1.287-1.287v-.225A1.289,1.289,0,0,0,224.313,435.2Zm.354,1.513a.354.354,0,0,1-.354.354h-1.159a.354.354,0,0,1-.354-.354v-.225a.354.354,0,0,1,.354-.354h1.158a.354.354,0,0,1,.354.354Z",
  transform: "translate(-221.867 -435.2)",
  fill: "#403f50",
  stroke: "#403f50",
  strokeWidth: 0.3
}))), React.createElement("g", {
  id: "Group_2013",
  "data-name": "Group 2013",
  transform: "translate(110.933)"
}, React.createElement("g", {
  id: "Group_2012",
  "data-name": "Group 2012"
}, React.createElement("path", {
  id: "Path_3048",
  "data-name": "Path 3048",
  d: "M125.113,0H112.62a1.689,1.689,0,0,0-1.687,1.687V26.313A1.689,1.689,0,0,0,112.62,28h12.493a1.689,1.689,0,0,0,1.687-1.687V1.687A1.689,1.689,0,0,0,125.113,0Zm.753,26.313a.754.754,0,0,1-.753.754H112.62a.754.754,0,0,1-.754-.753V1.687a.754.754,0,0,1,.754-.754h12.493a.755.755,0,0,1,.754.754V26.313Z",
  transform: "translate(-110.933 0)",
  fill: "#403f50",
  stroke: "#403f50",
  strokeWidth: 0.3
}))), React.createElement("g", {
  id: "Group_2015",
  "data-name": "Group 2015",
  transform: "translate(110.933 2.8)"
}, React.createElement("g", {
  id: "Group_2014",
  "data-name": "Group 2014",
  transform: "translate(0)"
}, React.createElement("path", {
  id: "Path_3049",
  "data-name": "Path 3049",
  d: "M126.334,51.2H111.4a.467.467,0,0,0-.467.467v19.6a.467.467,0,0,0,.467.467h14.933a.467.467,0,0,0,.467-.467v-19.6A.467.467,0,0,0,126.334,51.2Zm-.467,19.6h-14V52.133h14Z",
  transform: "translate(-110.934 -51.2)",
  fill: "#403f50",
  stroke: "#403f50",
  strokeWidth: 0.3
}))));
var SvgMobileLandscape = function SvgMobileLandscape(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 28.301,
    height: 16.167,
    viewBox: "0 0 28.301 16.167",
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMobileLandscape, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile-landscape.2a0f0cd1.svg";
export { ForwardRef as ReactComponent };